import React, { Component } from 'react';
import { Card, CardBody, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

//Simple bar
import SimpleBar from "simplebar-react";

class RecentlyActivity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false,
        }
    }

    render() {
        const {
            useCustomData = false,
            items = [],
            isFetching = false,
            title = "Last changes",
            emptyText = "No recent activity found.",
            maxHeight = "352px",
            cardClassName = "",
            cardStyle,
        } = this.props;

        if (useCustomData) {
            if (isFetching) {
                return (
                    <Card className={`card_box_Shadow ${cardClassName}`.trim()} style={cardStyle}>
                        <CardBody>
                            <div className="dt-field dt-skeleton mb-3" style={{ width: "55%", height: "24px" }} />
                            <div className="dt-field dt-skeleton mb-2" style={{ width: "100%", height: "48px" }} />
                            <div className="dt-field dt-skeleton mb-2" style={{ width: "100%", height: "48px" }} />
                            <div className="dt-field dt-skeleton" style={{ width: "100%", height: "48px" }} />
                        </CardBody>
                    </Card>
                );
            }

            return (
                <Card className={`card_box_Shadow ${cardClassName}`.trim()} style={cardStyle}>
                    <CardBody>
                        <h4 className="card-title mb-4">{title}</h4>

                        {!items.length ? (
                            <p className="text-muted small mb-0">{emptyText}</p>
                        ) : (
                            <SimpleBar style={{ maxHeight }}>
                                <ul className="list-unstyled activity-wid">
                                    {items.map((item, idx) => (
                                        <li key={`${item.dateLabel}-${item.text}-${idx}`} className="activity-list">
                                            <div className="activity-icon avatar-xs">
                                                <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                    <i className={item.iconClassName || "ri-history-line"}></i>
                                                </span>
                                            </div>
                                            <div>
                                                <div>
                                                    <h5 className="font-size-13">
                                                        {item.dateLabel}
                                                        {item.timeLabel ? (
                                                            <small className="text-muted"> {item.timeLabel}</small>
                                                        ) : null}
                                                    </h5>
                                                </div>

                                                <div>
                                                    <p className="text-muted mb-0">{item.text}</p>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </SimpleBar>
                        )}
                    </CardBody>
                </Card>
            );
        }

        return (
            <React.Fragment>
                <Col lg={4}>
                    <Card>
                        <CardBody>
                            <Dropdown className="float-end" isOpen={this.state.menu} toggle={() => this.setState({ menu: !this.state.menu })}>
                                <DropdownToggle tag="i" className="darrow-none card-drop" aria-expanded="false">
                                    <i className="mdi mdi-dots-vertical"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">

                                    <DropdownItem href="">Sales Report</DropdownItem>

                                    <DropdownItem href="">Export Report</DropdownItem>

                                    <DropdownItem href="">Profit</DropdownItem>

                                    <DropdownItem href="">Action</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>

                            <h4 className="card-title mb-4">Last changes</h4>

                            <SimpleBar style={{ maxHeight: "352px" }}>
                                <ul className="list-unstyled activity-wid">

                                    <li className="activity-list">
                                        <div className="activity-icon avatar-xs">
                                            <span className="avatar-title bg-soft-primary text-primary rounded-circle">
                                                <i className="ri-edit-2-fill"></i>
                                            </span>
                                        </div>
                                        <div>
                                            <div>
                                                <h5 className="font-size-13">28 Apr, 2020 <small className="text-muted">12:07 am</small></h5>
                                            </div>

                                            <div>
                                                <p className="text-muted mb-0">Responded to need “Volunteer Activities”</p>
                                            </div>
                                        </div>
                                    </li>

                                    
                                </ul>
                            </SimpleBar>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment>
        );
    }
}

export default RecentlyActivity;